import axios from 'axios'
import { getAuthHeader } from '@/utils/auth'

const API_BASE = process.env.VUE_APP_API_URL || '/api'

const authClient = axios.create({
  baseURL: API_BASE,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json'
  }
})

authClient.interceptors.request.use(config => {
  config.headers = {
    ...(config.headers || {}),
    ...getAuthHeader()
  }
  return config
})

authClient.interceptors.response.use(
  response => response.data,
  error => {
    const detail = error.response && error.response.data && error.response.data.detail
    const message = detail || error.message || '请求失败'
    return Promise.reject(new Error(message))
  }
)

export const authApi = {
  login: (data) => authClient.post('/auth/login', data),
  me: () => authClient.get('/auth/me'),
  logout: () => authClient.post('/auth/logout')
}

export default authApi
